



































import { pick } from '@/components/utils/core/object';
import { Vue, Component, Watch } from 'nuxt-property-decorator';
import type { Route } from 'vue-router';
import { RESERVED_QUERY_PARAMS } from './constants';
import SignInModal from '~/components/common/SignInModal/SignInModal.vue';
import SignUpModal from '~/components/common/SignUpModal/SignUpModal.vue';
import ContactUsModal from '~/components/common/ContactUsModal.vue';
import SetPasswordModal from '~/components/common/SetPasswordModal.vue';

/**
 * @deprecated Please consider registering the component that you want exactly where you need it.
 * By placing it here you are increasing the bundle size for the entire application.
 */
@Component({
  components: {
    // Non-lazy loaded, will be included in main bundle.
    SignInModal,
    SignUpModal,
    ContactUsModal,
    SetPasswordModal,
    // Lazy loaded, most of them are available to signed in users
    RestorePasswordModal: () => import('@/components/common/RestorePasswordModal.vue'),
    WinWireModal: () => import('@/components/partials/war-room/WinWire/WinWireModal.vue'),
    WarRoomOnboardingJobSearchModal: () =>
      import('@/components/partials/war-room-onboarding/WarRoomOnboardingJobSearchModal.vue'),
    WarRoomOnboardingExperienceModal: () =>
      import('@/components/partials/war-room-onboarding/WarRoomOnboardingExperienceModal.vue'),
    AnnouncementModal: () => import('@/components/common/AnnouncementModal/AnnoucementModal.vue'),
    HeaderReferralModal: () =>
      import('~/components/global/HeaderMenu/HeaderReferral/HeaderReferralModal/HeaderReferralModal.vue'),
    HeaderReferralHiredModal: () =>
      import('~/components/global/HeaderMenu/HeaderReferral/HeaderReferralHiredModal/HeaderReferralHiredModal.vue'),
  },
})
export default class Modals extends Vue {
  get isWarRoomPages() {
    return this.$route.path.startsWith(this.$pages.POSTS_PAGE.path);
  }

  @Watch('$route')
  onRouteChange(route: Route, oldRoute: Route) {
    this.toggle(route, oldRoute);
  }

  mounted() {
    this.toggle(this.$route);
    this.$modal.emitter.$on('before-close', this.handleClose);
  }

  beforeDestroy() {
    this.$modal.emitter.$off('before-close', this.handleClose);
  }

  toggle(route: Route, oldRoute?: Route) {
    const {
      query: { dynamic_modal: modal },
    } = route;

    if (oldRoute) {
      const {
        query: { dynamic_modal: oldModal, tab },
      } = oldRoute;
      if (oldModal) {
        this.$modal.hide(oldModal as string, { silent: true });
        this.$analytics.logEvent('global__modal__close', { name: oldModal, tab });
      }
    }

    if (modal) {
      this.$modal.show(modal as string, route.query);
      this.$analytics.logEvent('global__modal__open', { name: modal, tab: route.query.tab });
    }
  }

  async handleClose({ name }: ModalEvent) {
    // closing modals results in triggering nuxt middleware. this is not always desirable (e.g. when closing sign-in modal)
    if (name === this.$route.query.dynamic_modal) {
      try {
        await this.$router.replace({ query: pick(this.$route.query, RESERVED_QUERY_PARAMS) });
      } catch (e) {
        // fixme: here we silence the errors for duplicated navigation or interrupted navigation
        // this is non-breaking, but must be addressed
      }
    }
  }
}

type ModalEvent = { name: string; params: Record<string, { dynamic_modal: string }> };
